export enum TrackingEnv {
  local = 'dev',
  uat = 'uat',
  staging = 'stg',
  production = 'prd',
}
